import React from "react";

import logo from "src/assets/logo.svg";

import styles from "./DiscoverFooter.module.scss";

interface IFooterLink {
    label: string;
    href: string;
}

interface IFooterColumn {
    heading: string;
    links: IFooterLink[];
}

const columns: IFooterColumn[] = [
    {
        heading: "Company",
        links: [
            { label: "About",   href: "https://about.eagerdog.com/" },
            { label: "Clubs",   href: "https://about.eagerdog.com/kennelclubs" },
            { label: "Owners",  href: "https://about.eagerdog.com/copy-of-clubs" },
            { label: "Pricing", href: "https://about.eagerdog.com/pricing" }
        ]
    },
    {
        heading: "Support",
        links: [
            { label: "About",        href: "https://about.eagerdog.com/" },
            { label: "Contact Us",   href: "https://about.eagerdog.com/about" },
            { label: "Book a Demo",  href: "https://about.eagerdog.com/book-a-demo" },
            { label: "Resources",    href: "https://help.eagerdog.com/en/" }
        ]
    },
    {
        heading: "Social",
        links: [
            { label: "Facebook",  href: "https://web.facebook.com/groups/3783862578527261?_rdc=1&_rdr#" },
            { label: "Instagram", href: "https://www.instagram.com/eagerdoginc/" }
        ]
    }
];

const DiscoverFooter: React.FC = () => {
    const year = new Date().getFullYear();

    return (
        <footer className={styles.DiscoverFooter}>
            <div className={styles.inner}>
                <div className={styles.brand}>
                    <img src={logo} alt="EagerDog" className={styles.logo} />
                    <span className={styles.tagline}>The all-in-one platform for dog sport clubs and owners.</span>
                </div>
                <div className={styles.columns}>
                    {columns.map((col) => (
                        <div key={col.heading} className={styles.column}>
                            <div className={styles.heading}>{col.heading}</div>
                            <ul className={styles.list}>
                                {col.links.map((link) => (
                                    <li key={link.label}>
                                        <a
                                            href={link.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={styles.link}
                                        >
                                            {link.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
            <div className={styles.bottom}>
                <span>© {year} EagerDog Inc. All rights reserved.</span>
            </div>
        </footer>
    );
};

export default DiscoverFooter;
